// Button — wrapper fino sobre .m-btn do Maestro.
// Variants mapeiam para as modifiers oficiais:
//   primary -> .m-btn
//   secondary -> .m-btn.m-btn--secondary
//   quiet -> .m-btn.m-btn--quiet
//   danger -> .m-btn.m-btn--danger
// loading mostra "…" preservando a largura (sem spinner — fora do padrão).

import { ButtonHTMLAttributes, forwardRef } from 'react';

type Variant = 'primary' | 'secondary' | 'quiet' | 'danger';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  size?: 'md' | 'sm';
}

const CLS: Record<Variant, string> = {
  primary: 'm-btn',
  secondary: 'm-btn m-btn--secondary',
  quiet: 'm-btn m-btn--quiet',
  danger: 'm-btn m-btn--danger',
};

export const Button = forwardRef<HTMLButtonElement, Props>(function Button(
  { variant = 'primary', loading, size, children, className, disabled, ...rest },
  ref,
) {
  const parts = [CLS[variant]];
  if (size === 'sm') parts.push('m-btn--sm');
  if (className) parts.push(className);
  return (
    <button
      ref={ref}
      className={parts.join(' ')}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {children}
    </button>
  );
});
